<div class="page-container">
  <div class="debt-filters">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'ORDER_LIST.DEBTS.STAGE' | transloco }}</mat-label>
      <mat-select [(value)]="selectedStage" (selectionChange)="onStageChange()" [disabled]="isLoading">
        @for (stage of stageOptions; track stage.value) {
          <mat-option [value]="stage.value">{{ stage.translation | transloco }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="results-section">
    <mat-paginator
      [length]="totalData"
      [pageSizeOptions]="pageSizes"
      showFirstLastButtons
      [disabled]="isLoading"
    ></mat-paginator>

    <div class="overflow-auto">
      <table mat-table matSort matSortActive="orderNr" matSortDirection="desc" [dataSource]="dataSource" class="results-table mat-elevation-z2">
        <ng-container matColumnDef="orderNr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.ORDER_NR' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.orderNr }} </td>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.NAME' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.customerName }} </td>
        </ng-container>

        <ng-container matColumnDef="cellular">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.PHONE' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.cellular }} </td>
        </ng-container>

        <ng-container matColumnDef="carId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.CARID' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.carId }} </td>
        </ng-container>

        <ng-container matColumnDef="debtAmount">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.AMOUNT' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.debtAmount | number:'1.2-2' }} </td>
        </ng-container>

        <ng-container matColumnDef="additionalPaymentSent">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.ADDITIONAL_PAYMENT_SENT' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.additionalPaymentSent | date:'yyyy-MM-dd' }} </td>
        </ng-container>

        <ng-container matColumnDef="debtReminder1Sent">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.REMINDER_1' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.debtReminder1Sent | date:'yyyy-MM-dd' }} </td>
        </ng-container>

        <ng-container matColumnDef="debtReminder2Sent">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.REMINDER_2' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.debtReminder2Sent | date:'yyyy-MM-dd' }} </td>
        </ng-container>

        <ng-container matColumnDef="debtReminder3Sent">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.REMINDER_3' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.debtReminder3Sent | date:'yyyy-MM-dd' }} </td>
        </ng-container>

        <ng-container matColumnDef="invoice">
          <th mat-header-cell *matHeaderCellDef>{{ 'ORDER_LIST.DEBTS.INVOICE' | transloco }}</th>
          <td mat-cell *matCellDef="let order">
            @if (order.invoiceNr) {
              {{ order.invoiceNr }}
            } @else {
              <button mat-stroked-button color="warn" [disabled]="isLoading" (click)="createInvoice(order, $event)">
                {{ 'ORDER_DETAILS.BUTTONS.CREATE_INVOICE' | transloco }}
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="goToOrder(order.orderId)" class="clickable-row"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-data-content">
              <mat-icon>search_off</mat-icon>
              <span>{{ 'ORDER_LIST.DEBTS.NO_DEBTS' | transloco }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
